import React from 'react'
import { NavLink } from 'react-router-dom'
import { useModal } from '../../hooks/modal'
import { useDeleteRequest } from '../../hooks/request'
import { BUILDING_DETAIL } from '../../urls'
import BuildingUpdate from './BuildingUpdate'
import { format } from '../../utils/number'

export default function BuildingItem({ house, expense }) {
    const productRemove = useDeleteRequest({ url: BUILDING_DETAIL.replace('{id}', house.id) })

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            await productRemove.request()
            expense.request()
        }
    }

    const [showUpdateModal, hideUpdateModal] = useModal(
        <BuildingUpdate
            clients={house}
            item={house}
            onCancel={() => {
                expense.request()
                hideUpdateModal()
            }}
        />,
    )

    return (
        <div className="column is-one-third">
            <div
                className="box has-background-white p-4 has-shadow"
                style={{
                    borderRadius: '8px',
                    transition: 'transform 0.2s ease',
                    cursor: 'pointer',
                }}
            >
                <NavLink to={`/building/${house.id}`} className="has-text-dark">
                    <h3 className="title is-5 has-text-link mb-2">{house.name} блок</h3>
                </NavLink>

                <table className="table is-fullwidth is-bordered is-narrow">
                    <tbody>
                        <tr>
                            <td>
                                <span className="icon-text has-text-grey">
                                    <span className="icon">
                                        <ion-icon name="enter-outline" />
                                    </span>
                                    <span className="has-text-weight-medium">Подъезд</span>
                                </span>
                            </td>
                            <td>{house.entranceCount} та</td>
                        </tr>
                        <tr>
                            <td>
                                <span className="icon-text has-text-grey">
                                    <span className="icon">
                                        <ion-icon name="bed-outline" />
                                    </span>
                                    <span className="has-text-weight-medium">Хона</span>
                                </span>
                            </td>
                            <td>{house.roomCount} та</td>
                        </tr>
                        <tr>
                            <td>
                                <span className="icon-text has-text-grey">
                                    <span className="icon">
                                        <ion-icon name="location-outline" />
                                    </span>
                                    <span className="has-text-weight-medium">Манзил</span>
                                </span>
                            </td>
                            <td>{house.address}</td>
                        </tr>

                        <tr>
                            <td>
                                <span className="icon-text has-text-grey">
                                    <span className="icon">
                                        <ion-icon name="trending-down-outline" />
                                    </span>
                                    <span className="has-text-weight-medium">Харажатлар</span>
                                </span>
                            </td>
                            <td>{format(Number(house?.totalExpense))}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className="icon-text has-text-grey">
                                    <span className="icon">
                                        <ion-icon name="trending-up-outline" />
                                    </span>
                                    <span className="has-text-weight-medium">Даромад</span>
                                </span>
                            </td>
                            <td>{format(Number(house?.totalIncome))}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className="icon-text has-text-grey">
                                    <span className="icon">
                                        <ion-icon name="alert-outline" />
                                    </span>
                                    <span className="has-text-weight-medium">Қарздорлик</span>
                                </span>
                            </td>
                            <td>{format(Number(house?.totalBalance))}</td>
                        </tr>
                    </tbody>
                </table>

                <div className="is-flex is-justify-content-space-between">
                    <button onClick={onDelete} className="button is-danger is-light is-small">
                        <span className="icon">
                            <ion-icon name="trash-outline" />
                        </span>
                        <span>Ўчириш</span>
                    </button>
                    <button onClick={showUpdateModal} className="button is-info is-light is-small">
                        <span className="icon">
                            <ion-icon name="create-outline" />
                        </span>
                        <span>Таҳрирлаш</span>
                    </button>
                </div>
            </div>
        </div>
    )
}
